class NotifyMeSlideout extends HHBaseElement {
  constructor() {
    super()

    this.productForm = this.querySelector(
      '#slideout-notify-me-form'
    )
    this.emailInput = this.querySelector('#slideout-notify-me-email')
    this.skuInput = this.querySelector('#slideout-notify-me-sku')
    this.productIdInput = this.querySelector('#slideout-notify-me-product-id')
    this.variantIdInput = this.querySelector('#slideout-notify-me-variant-id')
    this.newsletterInput = this.querySelector('#slideout-notify-me-newsletter')
    this.atcButton = this.querySelector('.js-slideout-notify-me-atc')

    this.sendNotifyMeRequest = this.sendNotifyMeRequest.bind(this)
  }

  connectedCallback() {
    this.productForm.addEventListener('submit', this.sendNotifyMeRequest.bind(this))
    this._handleTriggerClick = this._handleTriggerClick.bind(this)
    document.addEventListener('click', this._handleTriggerClick)
  }

  disconnectedCallback() {
    this.productForm.removeEventListener('submit', this.sendNotifyMeRequest)
    document.removeEventListener('click', this._handleTriggerClick)
  }

  _handleTriggerClick(event) {
    const trigger = event.target.closest(
      '.js-open-slideout[data-target="notify-me"][data-variant-id]'
    )
    if (!trigger) return

    const variantId = trigger.dataset.variantId
    if (!variantId) return

    this.variantIdInput.value = variantId
    this.productIdInput.value = trigger.dataset.productId || ''
    this.skuInput.value = trigger.dataset.sku || ''

    const image = trigger.dataset.image
    const productTitle = trigger.dataset.productTitle || ''
    const variantTitle = trigger.dataset.variantTitle || ''

    const imageEl = this.querySelector('.js-slideout-notify-me-image')
    const titleEl = this.querySelector('.js-slideout-notify-me-title')
    const variantEl = this.querySelector('.js-slideout-notify-me-variant')

    if (imageEl) {
      imageEl.innerHTML = image ? `<img src="${image}" alt="${productTitle}" />` : ''
    }
    if (titleEl) titleEl.innerHTML = productTitle
    if (variantEl) {
      variantEl.innerHTML =
        variantTitle && variantTitle.toLowerCase() !== 'default title' ? variantTitle : ''
    }
  }

  async sendNotifyMeRequest(e) {
    e.preventDefault()
    const triggerButton = this.atcButton
    let request_success = false

    try {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }

      const email = this.emailInput.value
      const variantId = this.variantIdInput.value

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      }

      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoCompanyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      )

      if (!response.ok) {
        throw new Error(`Klaviyo BIS request failed: ${response.status}`)
      }

      if (this.newsletterInput.checked) {
        window._klOnsite = window._klOnsite || []
        window._klOnsite.push(['identify', { email: email }])
      }

      request_success = true
    } catch (error) {
      console.error(error)
    } finally {
      if (triggerButton) {
        triggerButton.removeAttribute('loading')
      }
      if (request_success == false) {
        var signupErrorMessage = document.getElementById("signup-error-message");
        signupErrorMessage.style.display = "block";
      } else {
        var signupMessage = document.getElementById("signup-message");
        signupMessage.style.display = "block";
        setTimeout(() => {
          this.closest('slide-panel')._shadowRoot.querySelector('.slide-panel__backdrop').click()
          signupMessage.style.display = "none";
        }, 2000);
      }
    }
  }
}

window.customElements.define('notify-me-slideout', NotifyMeSlideout)
